import PropTypes from 'prop-types';
import React from 'react';
import {
  ButtonToolbar,
  ButtonGroup,
  Button,
  MenuItem,
  DropdownButton,
  Modal,
} from 'react-bootstrap';
import diff from 'object-diff';

import { formalDate, fromNow, daysBetween } from '../../../core/date';

import BidDetailTable from './BidDetailTable';
import BidDetailForm from './BidDetailForm';

function getInitialValues(bid) {
  const nights = daysBetween(bid.bidset.event.end, bid.bidset.event.start);
  const initialValues = {
    suites: bid.bidset.suites,
    kings: bid.bidset.kings,
    queens: bid.bidset.queens,
    suite_rate: bid.suite_rate,
    king_rate: bid.king_rate,
    queen_rate: bid.queen_rate,
    hotel: {
      tax_rate: bid.hotel.tax_rate
        ? Number(bid.hotel.tax_rate * 100.0).toFixed(3)
        : bid.hotel.tax_rate,
      currency: bid.hotel.currency,
    },
    commission_rate: bid.commission_rate
      ? Number(bid.commission_rate * 100.0).toFixed(3)
      : bid.commission_rate,
    nights,
  };
  return initialValues;
}

class BidDetailPricing extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      edit: false,
    };
    this.handleEdit = this.handleEdit.bind(this);
    this.handleBidSubmit = this.handleBidSubmit.bind(this);
  }
  handleEdit() {
    this.setState({ edit: true });
  }
  handleBidSubmit(values) {
    const payload = diff(getInitialValues(this.props.bid), values);
    if (payload.hotel) {
      if (payload.hotel.tax_rate) {
        payload.hotel.tax_rate = Number(payload.hotel.tax_rate / 100.0).toFixed(3);
      }
    }
    if (payload.commission_rate) {
      payload.commission_rate = Number(payload.commission_rate / 100.0).toFixed(3);
    }
    this.props.editBid(this.props.bid.id, payload);
    this.setState({ edit: false });
  }

  render() {
    const canEdit = this.props.bid.buyer_state === 'PB' && !this.props.isTourManager;
    if (this.state.edit) {
      return (
        <BidDetailForm
          initialValues={getInitialValues(this.props.bid)}
          bid={this.props.bid}
          editBid={this.props.editBid}
          onSubmit={this.handleBidSubmit}
        />
      );
    }
    return (
      <BidDetailTable
        bid={this.props.bid}
        canEdit={canEdit}
        handleEdit={this.handleEdit}
        isTourManager={this.props.isTourManager}
      />
    );
  }
}

BidDetailPricing.propTypes = {
  bid: PropTypes.object.isRequired,
  isTourManager: PropTypes.bool.isRequired,
  editBid: PropTypes.func.isRequired,
};
export default BidDetailPricing;



// WEBPACK FOOTER //
// src/routes/tours/components/BidDetailPricing.js